import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project-imports
import Loadable from 'components/Loadable';
import MainLayout from 'layout/MainLayout';
import { PermissionGuard, routePermissions } from 'contexts/PermissionGuard';

// render - applications
const AppHome = Loadable(lazy(() => import('pages/home')));
const AppChat = Loadable(lazy(() => import('pages/apps/chat/chat')));
const AppServiceReports = Loadable(lazy(() => import('pages/apps/attendance/reports')));
const AppListContats = Loadable(lazy(() => import('pages/apps/customers/list')));
const AppGroupContacts = Loadable(lazy(() => import('pages/apps/customers/group')));
const AppChannels = Loadable(lazy(() => import('pages/apps/channels/')));
const AppCampaigns = Loadable(lazy(() => import('pages/apps/campaigns')));
const AppCampaignsDashboard = Loadable(lazy(() => import('pages/apps/campaigns/dashboard')));
const AppCommunities = Loadable(lazy(() => import('pages/apps/communities')));
const AppDashboardAttendance = Loadable(lazy(() => import('pages/apps/attendance/dashboard')));
const AppUsers = Loadable(lazy(() => import('pages/apps/users')));
const AppWATemplate = Loadable(lazy(() => import('pages/apps/whatsapp-template/whatsapp-template-list')));
const AppProfiles = Loadable(lazy(() => import('pages/apps/profiles')));
const AppAttendanceSettings = Loadable(lazy(() => import('pages/apps/attendance-settings')));
const AppNotificationSettings = Loadable(lazy(() => import('pages/apps/notification-settings')));
const AppRegistrations = Loadable(lazy(() => import('pages/apps/registrations')));
const AppAuditLog = Loadable(lazy(() => import('pages/apps/audit-log')));

// ==============================|| MAIN ROUTES ||============================== //

const AppsRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <MainLayout />,
      children: [
        {
          path: 'home',
          element: (
            <PermissionGuard requiredPermissions={routePermissions.home}>
              <AppHome />
            </PermissionGuard>
          )
        },

        {
          path: 'chat',
          element: (
            <PermissionGuard requiredPermissions={routePermissions.chat}>
              <AppChat />
            </PermissionGuard>
          )
        },
        {
          path: 'relatorio-atendimentos',
          element: (
            <PermissionGuard requiredPermissions={routePermissions['relatorio-atendimentos']}>
              <AppServiceReports />
            </PermissionGuard>
          )
        },
        {
          path: 'dashboard-atendimentos',
          element: (
            <PermissionGuard requiredPermissions={routePermissions['dashboard-atendimentos']}>
              <AppDashboardAttendance />
            </PermissionGuard>
          )
        },
        {
          path: 'whatsApp-Template',
          element: (
            <PermissionGuard requiredPermissions={routePermissions.templates}>
              <AppWATemplate />
            </PermissionGuard>
          )
        },
        {
          path: 'contatos',
          children: [
            {
              path: 'lista',
              element: (
                <PermissionGuard requiredPermissions={routePermissions.contatos}>
                  <AppListContats />
                </PermissionGuard>
              )
            },
            {
              path: 'grupos',
              element: (
                <PermissionGuard requiredPermissions={routePermissions.grupos}>
                  <AppGroupContacts />
                </PermissionGuard>
              )
            }
          ]
        },
        {
          path: 'canais',
          element: (
            <PermissionGuard requiredPermissions={routePermissions.canais}>
              <AppChannels />
            </PermissionGuard>
          )
        },
        {
          // RN07: endereço antigo continua funcionando, agora levando pra Cadastros
          path: 'departamento',
          element: (
            <Navigate
              to="/administracao/cadastros?tab=departamentos"
              replace
            />
          )
        },
        {
          path: 'campanhas',
          element: (
            <PermissionGuard requiredPermissions={routePermissions.campanhas}>
              <AppCampaigns />
            </PermissionGuard>
          )
        },
        {
          path: 'dashboard-campanhas',
          element: (
            <PermissionGuard requiredPermissions={routePermissions['dashboard-campanhas']}>
              <AppCampaignsDashboard />
            </PermissionGuard>
          )
        },
        {
          path: 'comunidades',
          element: (
            <PermissionGuard requiredPermissions={routePermissions.comunidades}>
              <AppCommunities />
            </PermissionGuard>
          )
        },
        {
          path: 'usuario',
          element: (
            <PermissionGuard requiredPermissions={routePermissions.usuario}>
              <AppUsers />
            </PermissionGuard>
          )
        },
        {
          // RN07: idem
          path: 'tags',
          element: (
            <Navigate
              to="/administracao/cadastros?tab=tags"
              replace
            />
          )
        },
        {
          path: 'administracao',
          children: [
            {
              path: 'perfis',
              element: (
                <PermissionGuard requiredPermissions={routePermissions.administracao}>
                  <AppProfiles />
                </PermissionGuard>
              )
            },
            {
              path: 'atendimento',
              element: (
                <PermissionGuard requiredPermissions={routePermissions['administracao-atendimento']}>
                  <AppAttendanceSettings />
                </PermissionGuard>
              )
            },
            {
              path: 'notificacoes',
              element: (
                <PermissionGuard requiredPermissions={routePermissions['administracao-notificacoes']}>
                  <AppNotificationSettings />
                </PermissionGuard>
              )
            },
            {
              path: 'cadastros',
              element: (
                <PermissionGuard requiredPermissions={routePermissions.cadastros}>
                  <AppRegistrations />
                </PermissionGuard>
              )
            },
            {
              path: 'auditoria',
              element: (
                <PermissionGuard requiredPermissions={routePermissions['administracao-auditoria']}>
                  <AppAuditLog />
                </PermissionGuard>
              )
            }
          ]
        }
      ]
    }
  ]
};

export default AppsRoutes;
